import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
// import { successNofication } from '../../../../../../shared/components/Notification';
import CustomerDetails from './components/CustomerDetails';
import CustomerPrimaryAddressBookDetailsModal from '../AddOrUpdate/components/CustomerDetailsModal';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { LinearProgress, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { showNotification } from 'src/shared/components/Notification';
import SnackbarContent from '@mui/material/SnackbarContent';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
const CustomerAddressBookDetailsIndex = () => {
  useEffect(() => {
    getAllCustomers();

  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const getAllCustomers = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllMerchantCustomers(localStorage.getItem("mi"));
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);

      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };



  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 65,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Customer Name',
        accessor: 'customerName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Code',
        accessor: 'merchantCustomerCode',
        disableGlobalFilter: false,

      },

      {
        Header: 'Mobile No.',
        accessor: 'mobileNo',
        disableGlobalFilter: false,

      },

      // {
      //   Header: 'PO BOX',
      //   accessor: 'poBoxNo',
      //   disableGlobalFilter: true,
      //   width: 35,
      // },

      // {
      //   Header: 'Address Type',
      //   accessor: 'addresstype',
      //   disableGlobalFilter: false,
      //   width: 35,
      //   Cell: ({ row }) =>
      //     row.original.addressType == 1 ? (
      //       <h6> <Badge color={"success"}>Primary</Badge></h6>
      //     ) :
      //       <h6><Badge color={"warning"}>Secondary</Badge></h6>
      // },
      {
        Header: 'Address Type',
        accessor: 'addressType',
        disableGlobalFilter: false,
        width: 60,
        Cell: ({ row }) =>
          row.original.addressType == 1 ? (
            <h6>
              <span className="badge bg-success">Primary</span>
            </h6>
          ) : (
            <h6>
              <span className="badge bg-warning">Secondary</span>
            </h6>
          )
      },
      {
        Header: 'Address',
        accessor: 'address',
        disableGlobalFilter: false,
        width: 250,

      },
      {
        Header: "Status",
        accessor: "status",
        disableGlobalFilter: false,
        width: 20,
        Cell: ({ row }) =>
          row.original.status == 1 ? (
            <h6>
              <span className="badge bg-success">ACTIVE</span>
            </h6>
          ) : (
            <h6>
              <span className="badge bg-danger">IN-ACTIVE</span>
            </h6>
          )
      },


      {
        Header: 'Action',
        accessor: 'edit',
        width: 20,
        disableSortBy: true,
        Cell: row => (
          <div className="icon-style">
            <div className="icon-style">
              <Tooltip title="Click here to Edit details">
                <EditIcon style={{ cursor: "pointer" }} onClick={() => edit(row.row.original)} />
              </Tooltip>
            </div>
          </div>
        ),
      },
    ],
    [],
  );

  const edit = async (event) => {
    if (event.merchantCustomerId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Merchant Customer Details")
    }
  }
  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) &&
        <CustomerDetails reactTableData={reactTableData} />
      }
      {loading && <LinearProgress color="primary" />}
      {isNoRecordFound && <CustomerDetails isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={"No Record Found"} />}
      {viewDetailPopup &&
        <CustomerPrimaryAddressBookDetailsModal
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          dataInfo={temp}
          isTitle={isTitle}
        />}
    </Container>
  );
};

export default CustomerAddressBookDetailsIndex;